export interface SocialNetworkDefinition {
  id: string;
  label: string;
}

export const SOCIAL_NETWORKS: SocialNetworkDefinition[] = [
  { id: "facebook", label: "Facebook" },
  { id: "x", label: "X / Twitter" },
  { id: "linkedin", label: "LinkedIn" },
  { id: "whatsapp", label: "WhatsApp" },
  { id: "telegram", label: "Telegram" },
  { id: "email", label: "Email" },
  { id: "copy-link", label: "Copier le lien" },
  { id: "reddit", label: "Reddit" },
  { id: "tumblr", label: "Tumblr" },
  { id: "pinterest", label: "Pinterest" },
  { id: "pocket", label: "Pocket" },
  { id: "line", label: "LINE" },
  { id: "vk", label: "VK" },
  { id: "xing", label: "Xing" },
  { id: "hackernews", label: "Hacker News" },
  { id: "meneame", label: "Meneame" },
  { id: "mix", label: "Mix" },
  { id: "flipboard", label: "Flipboard" },
  { id: "instapaper", label: "Instapaper" },
  { id: "buffer", label: "Buffer" },
  { id: "gmail", label: "Gmail" },
  { id: "yahoo-mail", label: "Yahoo Mail" },
  { id: "diaspora", label: "Diaspora" },
  { id: "blogger", label: "Blogger" },
  { id: "livejournal", label: "LiveJournal" },
  { id: "skype", label: "Skype" },
  { id: "sms", label: "SMS" },
  { id: "print", label: "Imprimer" }
];

export const DEFAULT_SOCIAL_NETWORKS = [
  "facebook",
  "x",
  "linkedin",
  "whatsapp",
  "telegram",
  "email",
  "copy-link"
];
